import { Component, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-preview-survey-like-dislike',
  templateUrl: './preview-survey-like-dislike.component.html',
  styleUrls: ['./preview-survey-like-dislike.component.scss']
})
export class PreviewSurveyLikeDislikeComponent {

  @Input() questions: any;
  @Input() isReadOnly: boolean;
  @Input() displayMode: string;
  constructor(public sanitizer: DomSanitizer) { }
}
